import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {GatewayService} from '@services/administration/gateway/gateway.service';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';

import {Log} from '@models/adminstration/gateway/log';
import {Gateway} from '@models/adminstration/gateway/gateway';
import {SortEvent, TableHeaderSortableDirective} from '@shared/table-header-sortable/table-header-sortable.directive';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';

@Component({
    selector: 'scitis-admin-gateway-log',
    templateUrl: './gateway-log.component.html',
    styleUrls: ['./gateway-log.component.scss'],
    standalone: false
})
export class GatewayLogComponent implements OnInit {

  @Input()
  gateway: Gateway = new Gateway();

  logs: Log[] = [];

  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  constructor(
      private gatewayService: GatewayService,
      private loadingIndicator: LoadingIndicatorService,
      private translate: TranslateService,
      private tableHeaderSortableService: TableHeaderSortableService) {
  }

  ngOnInit(): void {
    this.setLogs();
  }

  onColumnSort({column, direction}: SortEvent): void {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.logs = this.tableHeaderSortableService.sortItems<Log>(this.logs, column, direction);
  }

  private setLogs() {
    this.loadingIndicator.show(this.translate.instant('Loading'));
    this.gatewayService.getLogs(this.gateway.id).subscribe((logs: Log[]) => {
      this.logs = logs;
      this.loadingIndicator.hide();
    }, (error) => {
      console.log('Error loading gateway logs.', error);
      this.loadingIndicator.hide();
    });
  }

}
